export default __webpack_public_path__ + "static/media/sports-mans.2619e9b8.png";